import React, { useState } from 'react';
import { useTrackEvent } from '@wkda/funnel-components';
import SlideModal from '../../shared/SlideModal';
import GoogleRatingsReviews, { GoogleRatingsDisplay } from './GoogleReviews';
import { scrollTo } from '../../../helpers/scrollTo';
import { useAppConfiguration } from '@wkda/funnel-components';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function GoogleRatings() {
  const [isOpen, setIsOpen] = useState(false);
  const track = useTrackEvent();
  const appConfig = useAppConfiguration();
  const {
    hasGoogleReviewsSection = false
  } = appConfig?.marketingConfig;
  const handleClose = e => {
    e && e.preventDefault();
    setIsOpen(false);
  };
  const handleClick = () => {
    if (hasGoogleReviewsSection) {
      scrollTo('.google-reviews-section');
    } else {
      setIsOpen(true);
    }
    track({
      action: 'eventTracking',
      category: 'lead',
      eventData: {
        category: 'Google Ratings',
        action: 'Click',
        label: 'Google Ratings Section'
      }
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "google-ratings-display__container",
      children: /*#__PURE__*/_jsx(GoogleRatingsDisplay, {
        onClick: handleClick
      })
    }), /*#__PURE__*/_jsx("div", {
      hidden: !isOpen,
      children: /*#__PURE__*/_jsx(SlideModal, {
        isOpen: isOpen,
        id: "google-ratings",
        close: handleClose,
        trackingCategory: "Google Ratings",
        trackingLabel: "Google Ratings Modal",
        closeButtonVariant: "blue",
        showMobileDragIndicator: true,
        children: /*#__PURE__*/_jsx(GoogleRatingsReviews, {})
      })
    })]
  });
}